import { render, staticRenderFns } from "./HistorialMovimientosDialogComponent.vue?vue&type=template&id=f6efb106"
import script from "./HistorialMovimientosDialogComponent.vue?vue&type=script&lang=js"
export * from "./HistorialMovimientosDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports